module.exports = __webpack_public_path__ + "media/images/ico-gear@2x-29bebec30c75b63ee4bcefa9133fded9.png";